var map = {
	"./kittisak.jpg": "7ee2",
	"./korboon.svg": "e497",
	"./methinee.jpg": "0df0",
	"./nopphasit.jpg": "c9da",
	"./pimploy.svg": "c724",
	"./provider2.svg": "e7b3",
	"./sukamon.svg": "0a846",
	"./suleeporn.jpg": "4ce1",
	"./varangkana.jpg": "9887",
	"./yuratchar.jpg": "c134"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e664";